import { useMemo } from 'react';
import { useSearchParams } from 'react-router';

const useSelectedCountries = (): string[] => {
  const [searchParameters] = useSearchParams();
  return useMemo(() => searchParameters.getAll('country'), [searchParameters]);
};

export default useSelectedCountries;
